<template>
  <div>
    <div class="main">
      <div class="main--content">
        <div class="main--title">

          <!-- <a :href="`./images/pavilion-studios_supplement-op.pdf`">Download PDF</a> -->
        </div>
        <div class="grid-- mt-2">
             <router-link to="/list">List</router-link> <br> <span class="m-t2">● Slideshow</span>
        </div>
        <div class="main--images mt-2 mb-2" v-if="images">
              <section class="gallery p" :style="{ backgroundColor: backgroundColor || 'transparent' }" >
              <span class="control control-index fs-lrg"> {{ active + 1 }} <span class="controls--total"> {{ images.length }}</span></span>
              <vue-glide :perView="1"
                :startAt="0"
                :peek="0"
                :gap="0"
                :direction="'ltr'"
                :focusAt="'center'"
                :type="'slider'"
                :rewindDuration="10"
                v-model="active">
                <vue-glide-slide v-for="(image, key) in images" :key="`image-item${key}`">
                  <span @click="nextItem()"><img :src="`./images/${image.url}`"/></span>
                </vue-glide-slide>
              </vue-glide>
                <!-- <div class="controls mb-2 db">
                  <span class="control control--next" @click="nextItem()">Next image</span>
                </div> -->
            </section>
        </div>
      </div>
      <ol class="main--captions p mt-1 fs-sm" v-if="images">
              <li v-for="(image, key) in images" :key="`image-item${key}`">
                <span v-html="`${image.caption}`" class="caption"></span>
              </li>
      </ol>
      <div class="footer p mt-2 mb-1">
        <span>Follow on <a href="https://www.instagram.com/fieldexperiments">Instagram</a>. </span>
        <span><a href="https://confirmsubscription.com/h/t/D251C439679F6EF4" target="_blank">Sign up</a> to Newsletter. </span>
        <span><a href="mailto:mail@field-experiments.com">Contact us</a>. </span>
        <span>Copyright Field Experiments {{ new Date().getFullYear() }}. </span>
      </div>
    </div>
  </div>
</template>

<script>
import images from '@/data/gallery'
import { Glide, GlideSlide } from 'vue-glide-js'

export default {
  name: 'book',
  components: {
    [Glide.name]: Glide,
    [GlideSlide.name]: GlideSlide
  },
  props: {
    backgroundColor: String
  },
  data() {
    return {
      images: images,
      active: 0,
      totalItems: null
    }
  },
  mounted() {
    this.totalItems = this.images.length
  },
  methods: {
    nextItem() {
      if (this.active === this.totalItems - 1) this.active = 0
      else this.active += 1
    },
    previousItem() {
      if (this.active === 0) this.active = this.totalItems - 1
      else this.active -= 1
    }
  }
}
</script>

<style lang="scss">
.main {
  &--images {
    height: 100vh;
    .gallery {
      height: 93vh;
    }
  }
  .footer {
    @include media_query(mobile-port) {
      font-size: 24px;
    }
    span {
      @include media_query(mobile-port) {
        display: block;
        width:100%;
      }
    }
    a {
      color: gray;
    &:hover{
      color: gray;
      cursor: pointer;
    }
  }
}
  .main {
    &--captions {
      list-style: none;
      text-align: left;
      counter-reset: fe-counter;
      li {
        counter-increment: fe-counter;
        display: flex;
        .caption {
          flex:1 1;
        }
      }
      li::before {
        content: "" counter(fe-counter);
        flex:0 0 40px;
      }
    }
  }

  .controls {
    &--total {
      display: inline-block;
      margin-left: 2rem;
    }
  }
  &--captions {
    column-count: 3;
    @include media_query(mobile-port) {
      column-count: 1;
    }
  }
}


</style>

<style lang="scss">
.gallery {
@import "node_modules/@glidejs/glide/src/assets/sass/glide.core";
.glide {
  &__slides {
    height: 95vh;
  }
  &__slide {
    height: 100%;
    img {
      cursor: pointer;
      object-fit: contain;
      height: 100%;
      width: 100%;
      max-height: 100%;
      max-width: 100%;
      object-position: bottom left;
      @include media_query(mobile-port) {
        height: auto;
      }
    }
    span {
      cursor: pointer;
      height: 100%;
      width: 100%;
    }
  }
}
}
@include media_query(mobile-port) {
  .main--images, .main--images .gallery, .gallery .glide__slides {
    height: inherit;
  }
}
</style>
